import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';

@Component({
  selector: 'rx-applications-bookings-shell',
  templateUrl: './bookings-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingsShellComponent {
  readonly isShowCPLGroupBookingEnabled$ = inject(ConfigFacade).isShowCPLGroupBookingEnabled$;
}
